// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/sidebarBg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar in open state */
.sidebarMinWrapper > div {
   width: 22vw;
   height: 100vh;
   border: 1px solid #e8e7e7;
   border-top-right-radius: 10px;
   border-bottom-right-radius: 10px;
   position: relative;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   background-repeat: no-repeat;
   background-position: center;
   transition: width 0.5s ease-in-out;
}

/* Sidebar in closed state */
.sidebarMinWrapperClose > div {
   width: 8vw;
   height: 100vh;
   border: 1px solid #e8e7e7;
   border-top-right-radius: 10px;
   border-bottom-right-radius: 10px;
   position: relative;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   background-repeat: no-repeat;
   background-position: center;
   transition: width 0.5s ease-in-out;
}

/* Wrapper styles */
/* .sidebarMinWrapper,
.sidebarMinWrapperClose {
   position: fixed;
   top: 0;
   z-index: 10;
} */

.topbarMainWrapper {
   height: 48px;
   border: 1px solid #e8e7e7;
   border-radius: 10px;
   box-sizing: border-box;
   margin-left: 4px;
   z-index: 9;
   background-color: #fff;
   position: sticky;
   width: 99.2%;
   margin-right: 280px;
   top: 0px;
   display: flex;
   align-items: center;
}

.topbarMainWrapper > div {
   width: 100%;
   position: relative;
   display: flex;
   align-items: center;
}
.topbarMainWrapper > div > div {
   display: flex;
   align-items: center;
   position: absolute;
   right: 20px;
   z-index: 100;
}

.profileBtnWrapper {
   display: flex;
   justify-content: space-between;
   align-items: center;
   cursor: pointer;
   z-index: 100;
}

.profileBtnWrapper img {
   width: 34px;
   height: 34px;
   margin-right: 10px;
   border-radius: 40px;
   border: #c6e4cc 2px solid;
   object-fit: contain;
}

.profileBtnWrapper h6 {
   margin: 0px;
   font-weight: 700 !important;
   font-size: 14px;
}

.profileBtnWrapper > div > div > div {
   width: 8px;
   height: 8px;
   background-color: #76b95f;
   margin-right: 6px;
   border-radius: 10px;
}

.profileBtnWrapper > div > div {
   display: flex;
   align-items: center;
   margin-top: 4px;
}

.profileBtnWrapper > :nth-child(3) {
   margin-left: 10px;
   color: #8a92a6;
}
.sidebarMinWrapper > div > img {
   width: 65%;
   margin: auto;
   display: block;
   margin-top: 6px;
}

.sidebarMinWrapperClose > div > img {
   width: 100%;
   margin: auto;
   display: block;
   margin-top: 16px;
   transition: width 0.5s ease-in-out;
}

.hamburger {
   position: absolute;
   display: flex;
   align-items: center;
   justify-content: center;
   width: 30px;
   height: 30px;
   background-color: #d6ffdd;
   border-radius: 50px;
   top: 10px;
   right: -16px;
   z-index: 11;
   box-shadow: rgba(153, 153, 153, 0.25) 0px 0.0625em 0.0625em,
      rgba(109, 109, 109, 0.25) 0px 0.125em 0.5em,
      rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
   cursor: pointer;
   transition: 0.2s;
}

.hamburger:hover {
   background-color: #bdf6c6;
   transition: 0.2s;
}

.sidebar-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   position: absolute;
   bottom: 0px;
   width: 100%;
   z-index: 1;
   background-color: #fff;
   padding: 12px;
   border-radius: 10px;
}

.sidebar-footerClose {
   display: flex;
   justify-content: center;
   align-items: center;
   position: absolute;
   bottom: 0px;
   width: 100%;
   z-index: 1;
   background-color: #fff;
   padding: 12px;
   border-radius: 10px;
}

.sidebar-footer > h6 {
   font-weight: 700;
   font-size: 14px;
   text-align: center !important;
}

.sidebar-footerClose > h6 {
   font-weight: 700;
   font-size: 12px;
   text-align: center !important;
}

.NavButtonsWrapper {
   height: 78vh;
   margin: auto;
   overflow-y: auto;
   padding: 30px 14px 10px 14px;
}

.NavButtonsWrapperClose {
   height: 78vh;
   margin: auto;
   overflow-y: auto;
   padding: 30px 5px 10px 5px;
}

.NavButtonsWrapperClose::-webkit-scrollbar {
   display: none;
}

.NavButtonsWrapper::-webkit-scrollbar {
   display: none;
}
.CloasedSidebarNavBtn {
   padding: 5px;
}

.tab_inactive button {
   display: flex;
   width: 100%;
   margin-bottom: 10px;
   border: none;
   border-radius: 4px;
   color: #8a92a6;
   text-align: start;
   padding: 10px 0px 10px 20px;
   background-color: transparent;
   outline: none;
   font-weight: 600;
   position: relative;
   overflow: hidden;
   align-items: center;
   z-index: 1;
}

.tab_inactive button::before {
   content: "";
   position: absolute;
   top: 50%;
   left: 50%;
   width: 100%;
   height: 100%;
   background: linear-gradient(
      90deg,
      rgba(40, 143, 67, 1) 0%,
      rgba(118, 185, 95, 1) 100%
   );
   transition: transform 0.4s ease;
   transform: translate(-50%, -50%) scale(0);
   z-index: 0;
}

.tab_inactive button:hover::before {
   transform: translate(-50%, -50%) scale(1);
}

.tab_inactive button div {
   z-index: 1;
}

.tab_inactive button :nth-child(1) {
   display: flex;
}

.tab_inactive button:hover {
   color: #fff;
}

.tab_inactive button:focus {
   outline: none;
}

.tab_inactive button svg {
   fill: #8a92a6;
   margin-right: 10px;
   position: relative;
   z-index: 1;
}

.tab_inactive button:hover svg {
   fill: #fff;
}

.tab_active button {
   display: flex;
   width: 100%;
   margin-bottom: 10px;
   border: none;
   padding: 10px 0px 10px 20px;
   border-radius: 4px;
   color: #fff;
   text-align: start;
   outline: none;
   font-weight: 600;
   align-items: center;
   background: linear-gradient(
      90deg,
      rgba(40, 143, 67, 1) 0%,
      rgba(118, 185, 95, 1) 100%
   ) !important;
}

.tab_active button :nth-child(1) {
   display: flex;
}

.tab_active button svg {
   fill: #fff;
   margin-right: 10px;
}

.sidebarTabBtn {
   display: flex;
   justify-content: space-between;
}

.CloasedSidebarNavBtn {
   display: flex;
   justify-content: center;
   padding: 10px !important;
   text-align: center !important;
   width: fit-content !important;
   margin: auto;
   pointer-events: none !important;
}

.CloasedSidebarNavBtn > :first-child > :first-child svg {
   margin: 0px !important;
}

.NavBtnDroppdown {
   width: 100%;
   background-color: #ddffe3;
   margin-bottom: 16px;
   margin-top: -6px;
   color: #8a92a6;
}

.dropdownTabActive {
   padding: 8px 8px 8px 30px;
   font-weight: 600;
   font-size: 16px;
   background-color: #76B95F ;
   color: #fff;
}
.dropdownTabInActive {
   padding: 8px 8px 8px 30px;
   font-weight: 600;
   font-size: 16px;
}

.dropdownTabActive > svg {
   fill: #fff;
   margin-right: 6px;
}

.dropdownTabInActive > svg {
   fill: #8a92a6;
   margin-right: 6px;
}

.dropdownTabInActive:hover {
   background: #b8fdc5;
   cursor: pointer;
}

.notificationIconWrapper {
   margin-right: 30px;
}

.profile-dropdown-menu,
.profile-dropdown-menu-close {
   position: absolute;
   width: 120px;
   right: 0px;
   top: 36px !important;
}

.profile-dropdown-menu-close {
   width: 0px;
   transition: width 1s ease-in-out;
}

.profile-dropdown-menu > div,
.profile-dropdown-menu-close > div {
   position: relative;
   top: 10px;
   background-color: #fff;
   border-radius: 10px;
   transition: top 0.4s ease-in-out;
   box-shadow: rgba(93, 177, 116, 0.8) 0px 5px 15px 0px;
}

.profile-dropdown-menu > div {
   right: -20px;
   top: 10px;
}

.profile-dropdown-menu-close > div {
   right: -20px;
   top:-200px
}

.profile-dropdown-menu > div > div,
.profile-dropdown-menu-close > div > div {
   padding: 6px 16px;
   font-weight: 600;
   cursor: pointer;
}

.profile-dropdown-menu > div > div:hover{
   border-radius: 10px;
   background-color: var( --Light_Green);
}


.profile-dropdown-menu > div :last-child,
.profile-dropdown-menu-close > div :last-child {
   color: red;
}

/* ------------------------ Media Query ---------------------- */

@media (max-width: 1200px) {
   .sidebarMinWrapper > div {
      width: 26vw;
   }
}

@media (max-width: 1000px) {
   .sidebarMinWrapper {
      position: fixed;
      z-index: 100;
      background-color: #fff;
   }

   .sidebarMinWrapper > div {
      width: 300px;
   }
}

@media (max-width: 800px) {
   .sidebarMinWrapperClose > div {
      width: 12vw;
   }
}
`, "",{"version":3,"sources":["webpack://./src/commanComponents/NavigationBar/navbar.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;GACG,WAAW;GACX,aAAa;GACb,yBAAyB;GACzB,6BAA6B;GAC7B,gCAAgC;GAChC,kBAAkB;GAClB,yDAAuD;GACvD,4BAA4B;GAC5B,2BAA2B;GAC3B,kCAAkC;AACrC;;AAEA,4BAA4B;AAC5B;GACG,UAAU;GACV,aAAa;GACb,yBAAyB;GACzB,6BAA6B;GAC7B,gCAAgC;GAChC,kBAAkB;GAClB,yDAAuD;GACvD,4BAA4B;GAC5B,2BAA2B;GAC3B,kCAAkC;AACrC;;AAEA,mBAAmB;AACnB;;;;;GAKG;;AAEH;GACG,YAAY;GACZ,yBAAyB;GACzB,mBAAmB;GACnB,sBAAsB;GACtB,gBAAgB;GAChB,UAAU;GACV,sBAAsB;GACtB,gBAAgB;GAChB,YAAY;GACZ,mBAAmB;GACnB,QAAQ;GACR,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,mBAAmB;AACtB;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,kBAAkB;GAClB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;GACnB,eAAe;GACf,YAAY;AACf;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,mBAAmB;GACnB,yBAAyB;GACzB,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,2BAA2B;GAC3B,eAAe;AAClB;;AAEA;GACG,UAAU;GACV,WAAW;GACX,yBAAyB;GACzB,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,cAAc;AACjB;AACA;GACG,UAAU;GACV,YAAY;GACZ,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,cAAc;GACd,gBAAgB;GAChB,kCAAkC;AACrC;;AAEA;GACG,kBAAkB;GAClB,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,yBAAyB;GACzB,mBAAmB;GACnB,SAAS;GACT,YAAY;GACZ,WAAW;GACX;;oDAEiD;GACjD,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,kBAAkB;GAClB,WAAW;GACX,WAAW;GACX,UAAU;GACV,sBAAsB;GACtB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,kBAAkB;GAClB,WAAW;GACX,WAAW;GACX,UAAU;GACV,sBAAsB;GACtB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,6BAA6B;AAChC;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,6BAA6B;AAChC;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,gBAAgB;GAChB,4BAA4B;AAC/B;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;AACA;GACG,YAAY;AACf;;AAEA;GACG,aAAa;GACb,WAAW;GACX,mBAAmB;GACnB,YAAY;GACZ,kBAAkB;GAClB,cAAc;GACd,iBAAiB;GACjB,2BAA2B;GAC3B,6BAA6B;GAC7B,aAAa;GACb,gBAAgB;GAChB,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,UAAU;AACb;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,WAAW;GACX,YAAY;GACZ;;;;IAIC;GACD,+BAA+B;GAC/B,yCAAyC;GACzC,UAAU;AACb;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,aAAa;GACb,WAAW;GACX,mBAAmB;GACnB,YAAY;GACZ,2BAA2B;GAC3B,kBAAkB;GAClB,WAAW;GACX,iBAAiB;GACjB,aAAa;GACb,gBAAgB;GAChB,mBAAmB;GACnB;;;;eAIY;AACf;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,8BAA8B;AACjC;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,wBAAwB;GACxB,6BAA6B;GAC7B,6BAA6B;GAC7B,YAAY;GACZ,+BAA+B;AAClC;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,WAAW;GACX,yBAAyB;GACzB,mBAAmB;GACnB,gBAAgB;GAChB,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,gBAAgB;GAChB,eAAe;GACf,0BAA0B;GAC1B,WAAW;AACd;AACA;GACG,yBAAyB;GACzB,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,UAAU;GACV,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,iBAAiB;AACpB;;AAEA;GACG,mBAAmB;GACnB,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;;GAEG,kBAAkB;GAClB,YAAY;GACZ,UAAU;GACV,oBAAoB;AACvB;;AAEA;GACG,UAAU;GACV,gCAAgC;AACnC;;AAEA;;GAEG,kBAAkB;GAClB,SAAS;GACT,sBAAsB;GACtB,mBAAmB;GACnB,gCAAgC;GAChC,oDAAoD;AACvD;;AAEA;GACG,YAAY;GACZ,SAAS;AACZ;;AAEA;GACG,YAAY;GACZ;AACH;;AAEA;;GAEG,iBAAiB;GACjB,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,mBAAmB;GACnB,qCAAqC;AACxC;;;AAGA;;GAEG,UAAU;AACb;;AAEA,gEAAgE;;AAEhE;GACG;MACG,WAAW;GACd;AACH;;AAEA;GACG;MACG,eAAe;MACf,YAAY;MACZ,sBAAsB;GACzB;;GAEA;MACG,YAAY;GACf;AACH;;AAEA;GACG;MACG,WAAW;GACd;AACH","sourcesContent":["/* Sidebar in open state */\n.sidebarMinWrapper > div {\n   width: 22vw;\n   height: 100vh;\n   border: 1px solid #e8e7e7;\n   border-top-right-radius: 10px;\n   border-bottom-right-radius: 10px;\n   position: relative;\n   background-image: url(\"../../assets/img/sidebarBg.svg\");\n   background-repeat: no-repeat;\n   background-position: center;\n   transition: width 0.5s ease-in-out;\n}\n\n/* Sidebar in closed state */\n.sidebarMinWrapperClose > div {\n   width: 8vw;\n   height: 100vh;\n   border: 1px solid #e8e7e7;\n   border-top-right-radius: 10px;\n   border-bottom-right-radius: 10px;\n   position: relative;\n   background-image: url(\"../../assets/img/sidebarBg.svg\");\n   background-repeat: no-repeat;\n   background-position: center;\n   transition: width 0.5s ease-in-out;\n}\n\n/* Wrapper styles */\n/* .sidebarMinWrapper,\n.sidebarMinWrapperClose {\n   position: fixed;\n   top: 0;\n   z-index: 10;\n} */\n\n.topbarMainWrapper {\n   height: 48px;\n   border: 1px solid #e8e7e7;\n   border-radius: 10px;\n   box-sizing: border-box;\n   margin-left: 4px;\n   z-index: 9;\n   background-color: #fff;\n   position: sticky;\n   width: 99.2%;\n   margin-right: 280px;\n   top: 0px;\n   display: flex;\n   align-items: center;\n}\n\n.topbarMainWrapper > div {\n   width: 100%;\n   position: relative;\n   display: flex;\n   align-items: center;\n}\n.topbarMainWrapper > div > div {\n   display: flex;\n   align-items: center;\n   position: absolute;\n   right: 20px;\n   z-index: 100;\n}\n\n.profileBtnWrapper {\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n   cursor: pointer;\n   z-index: 100;\n}\n\n.profileBtnWrapper img {\n   width: 34px;\n   height: 34px;\n   margin-right: 10px;\n   border-radius: 40px;\n   border: #c6e4cc 2px solid;\n   object-fit: contain;\n}\n\n.profileBtnWrapper h6 {\n   margin: 0px;\n   font-weight: 700 !important;\n   font-size: 14px;\n}\n\n.profileBtnWrapper > div > div > div {\n   width: 8px;\n   height: 8px;\n   background-color: #76b95f;\n   margin-right: 6px;\n   border-radius: 10px;\n}\n\n.profileBtnWrapper > div > div {\n   display: flex;\n   align-items: center;\n   margin-top: 4px;\n}\n\n.profileBtnWrapper > :nth-child(3) {\n   margin-left: 10px;\n   color: #8a92a6;\n}\n.sidebarMinWrapper > div > img {\n   width: 65%;\n   margin: auto;\n   display: block;\n   margin-top: 6px;\n}\n\n.sidebarMinWrapperClose > div > img {\n   width: 100%;\n   margin: auto;\n   display: block;\n   margin-top: 16px;\n   transition: width 0.5s ease-in-out;\n}\n\n.hamburger {\n   position: absolute;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   width: 30px;\n   height: 30px;\n   background-color: #d6ffdd;\n   border-radius: 50px;\n   top: 10px;\n   right: -16px;\n   z-index: 11;\n   box-shadow: rgba(153, 153, 153, 0.25) 0px 0.0625em 0.0625em,\n      rgba(109, 109, 109, 0.25) 0px 0.125em 0.5em,\n      rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;\n   cursor: pointer;\n   transition: 0.2s;\n}\n\n.hamburger:hover {\n   background-color: #bdf6c6;\n   transition: 0.2s;\n}\n\n.sidebar-footer {\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: absolute;\n   bottom: 0px;\n   width: 100%;\n   z-index: 1;\n   background-color: #fff;\n   padding: 12px;\n   border-radius: 10px;\n}\n\n.sidebar-footerClose {\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   position: absolute;\n   bottom: 0px;\n   width: 100%;\n   z-index: 1;\n   background-color: #fff;\n   padding: 12px;\n   border-radius: 10px;\n}\n\n.sidebar-footer > h6 {\n   font-weight: 700;\n   font-size: 14px;\n   text-align: center !important;\n}\n\n.sidebar-footerClose > h6 {\n   font-weight: 700;\n   font-size: 12px;\n   text-align: center !important;\n}\n\n.NavButtonsWrapper {\n   height: 78vh;\n   margin: auto;\n   overflow-y: auto;\n   padding: 30px 14px 10px 14px;\n}\n\n.NavButtonsWrapperClose {\n   height: 78vh;\n   margin: auto;\n   overflow-y: auto;\n   padding: 30px 5px 10px 5px;\n}\n\n.NavButtonsWrapperClose::-webkit-scrollbar {\n   display: none;\n}\n\n.NavButtonsWrapper::-webkit-scrollbar {\n   display: none;\n}\n.CloasedSidebarNavBtn {\n   padding: 5px;\n}\n\n.tab_inactive button {\n   display: flex;\n   width: 100%;\n   margin-bottom: 10px;\n   border: none;\n   border-radius: 4px;\n   color: #8a92a6;\n   text-align: start;\n   padding: 10px 0px 10px 20px;\n   background-color: transparent;\n   outline: none;\n   font-weight: 600;\n   position: relative;\n   overflow: hidden;\n   align-items: center;\n   z-index: 1;\n}\n\n.tab_inactive button::before {\n   content: \"\";\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   width: 100%;\n   height: 100%;\n   background: linear-gradient(\n      90deg,\n      rgba(40, 143, 67, 1) 0%,\n      rgba(118, 185, 95, 1) 100%\n   );\n   transition: transform 0.4s ease;\n   transform: translate(-50%, -50%) scale(0);\n   z-index: 0;\n}\n\n.tab_inactive button:hover::before {\n   transform: translate(-50%, -50%) scale(1);\n}\n\n.tab_inactive button div {\n   z-index: 1;\n}\n\n.tab_inactive button :nth-child(1) {\n   display: flex;\n}\n\n.tab_inactive button:hover {\n   color: #fff;\n}\n\n.tab_inactive button:focus {\n   outline: none;\n}\n\n.tab_inactive button svg {\n   fill: #8a92a6;\n   margin-right: 10px;\n   position: relative;\n   z-index: 1;\n}\n\n.tab_inactive button:hover svg {\n   fill: #fff;\n}\n\n.tab_active button {\n   display: flex;\n   width: 100%;\n   margin-bottom: 10px;\n   border: none;\n   padding: 10px 0px 10px 20px;\n   border-radius: 4px;\n   color: #fff;\n   text-align: start;\n   outline: none;\n   font-weight: 600;\n   align-items: center;\n   background: linear-gradient(\n      90deg,\n      rgba(40, 143, 67, 1) 0%,\n      rgba(118, 185, 95, 1) 100%\n   ) !important;\n}\n\n.tab_active button :nth-child(1) {\n   display: flex;\n}\n\n.tab_active button svg {\n   fill: #fff;\n   margin-right: 10px;\n}\n\n.sidebarTabBtn {\n   display: flex;\n   justify-content: space-between;\n}\n\n.CloasedSidebarNavBtn {\n   display: flex;\n   justify-content: center;\n   padding: 10px !important;\n   text-align: center !important;\n   width: fit-content !important;\n   margin: auto;\n   pointer-events: none !important;\n}\n\n.CloasedSidebarNavBtn > :first-child > :first-child svg {\n   margin: 0px !important;\n}\n\n.NavBtnDroppdown {\n   width: 100%;\n   background-color: #ddffe3;\n   margin-bottom: 16px;\n   margin-top: -6px;\n   color: #8a92a6;\n}\n\n.dropdownTabActive {\n   padding: 8px 8px 8px 30px;\n   font-weight: 600;\n   font-size: 16px;\n   background-color: #76B95F ;\n   color: #fff;\n}\n.dropdownTabInActive {\n   padding: 8px 8px 8px 30px;\n   font-weight: 600;\n   font-size: 16px;\n}\n\n.dropdownTabActive > svg {\n   fill: #fff;\n   margin-right: 6px;\n}\n\n.dropdownTabInActive > svg {\n   fill: #8a92a6;\n   margin-right: 6px;\n}\n\n.dropdownTabInActive:hover {\n   background: #b8fdc5;\n   cursor: pointer;\n}\n\n.notificationIconWrapper {\n   margin-right: 30px;\n}\n\n.profile-dropdown-menu,\n.profile-dropdown-menu-close {\n   position: absolute;\n   width: 120px;\n   right: 0px;\n   top: 36px !important;\n}\n\n.profile-dropdown-menu-close {\n   width: 0px;\n   transition: width 1s ease-in-out;\n}\n\n.profile-dropdown-menu > div,\n.profile-dropdown-menu-close > div {\n   position: relative;\n   top: 10px;\n   background-color: #fff;\n   border-radius: 10px;\n   transition: top 0.4s ease-in-out;\n   box-shadow: rgba(93, 177, 116, 0.8) 0px 5px 15px 0px;\n}\n\n.profile-dropdown-menu > div {\n   right: -20px;\n   top: 10px;\n}\n\n.profile-dropdown-menu-close > div {\n   right: -20px;\n   top:-200px\n}\n\n.profile-dropdown-menu > div > div,\n.profile-dropdown-menu-close > div > div {\n   padding: 6px 16px;\n   font-weight: 600;\n   cursor: pointer;\n}\n\n.profile-dropdown-menu > div > div:hover{\n   border-radius: 10px;\n   background-color: var( --Light_Green);\n}\n\n\n.profile-dropdown-menu > div :last-child,\n.profile-dropdown-menu-close > div :last-child {\n   color: red;\n}\n\n/* ------------------------ Media Query ---------------------- */\n\n@media (max-width: 1200px) {\n   .sidebarMinWrapper > div {\n      width: 26vw;\n   }\n}\n\n@media (max-width: 1000px) {\n   .sidebarMinWrapper {\n      position: fixed;\n      z-index: 100;\n      background-color: #fff;\n   }\n\n   .sidebarMinWrapper > div {\n      width: 300px;\n   }\n}\n\n@media (max-width: 800px) {\n   .sidebarMinWrapperClose > div {\n      width: 12vw;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
